import {Component, inject, OnInit, TemplateRef} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {ContentHeaderService} from '../../services/content-header/content-header.service';

@Component({
  selector: 'app-content-header',
  imports: [
    NgTemplateOutlet
  ],
  templateUrl: './content-header.component.html',
  // styleUrl: './content-header.component.scss'
  standalone: true
})
export class ContentHeaderComponent implements OnInit {
  private contentHeaderService = inject(ContentHeaderService);
  contentRef: TemplateRef<string> | null = null;

  ngOnInit() {
    this.contentHeaderService.content$.subscribe({
      next: value => {
        this.contentRef = value;
      }
    })
  }
}
